import Pagination from '../Pagination/index';

export default {
    people: null,
    error: '',
    person: {
        name: null,
        school_year: null,
        email: null,
        phone: null,
        bible_study_leader: null,
        active_bible_study_participant: null,
        first_name: null,
        gender_id: null
    },
    genders: null,
    schoolYears: null,
    roles: null,
    locations: null
};
